import { ChartColumn, FileText } from "lucide-react";
import { useTranslation } from "react-i18next";

import BaseButton from "@/components_v2/Button/BaseButton";
import {
  BUTTON_SIZES,
  BUTTON_VARIANTS,
} from "@/components_v2/Button/constants";
import { SampleSurveyCardProps } from "@/features/survey/guidance/types";

const SampleSurveyCard = ({
  title,
  reportPath,
  reportViewPath,
  surveyType,
}: SampleSurveyCardProps) => {
  const { t } = useTranslation();

  return (
    <div
      className="exemplary-sip-card flex flex-col gap-300"
      aria-label={`${title}`}
    >
      <h4 className="exemplary-sip-card-title body-m-medium">{title}</h4>

      <div className="flex gap-200 flex-wrap">
        <BaseButton
          variant={BUTTON_VARIANTS.PRIMARY}
          size={BUTTON_SIZES.EXTRA_SMALL}
          onClick={() => window.open(reportPath, "_blank")}
          leadingIcon={<FileText size={16} />}
        >
          {t("survey.labels.viewSurvey", { surveyType })}
        </BaseButton>

        <BaseButton
          variant={BUTTON_VARIANTS.TERTIARY}
          size={BUTTON_SIZES.EXTRA_SMALL}
          onClick={() => window.open(reportViewPath, "_blank")}
          leadingIcon={<ChartColumn size={16} />}
        >
          {t("survey.labels.viewReportView")}
        </BaseButton>
      </div>
    </div>
  );
};

export default SampleSurveyCard;
